import styled, { css } from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  desktopAndAbove,
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

export const tileCss = css`
  --tile-height: 571px;
  overflow: hidden;
  padding: var(--double-unit);
  flex-shrink: 0;
  width: 100%;

  @media ${tabletAndAbove} {
    width: calc(50% - var(--unit));
  }

  @media ${laptopAndAbove} {
    padding: var(--triple-unit);
  }

  @media ${desktopAndAbove} {
    width: calc(1 / 3 * 100% - var(--intermediate-unit));
  }
`;

export const RecommendationSkeleton = styled(Skeleton)`
  ${tileCss}
  height: var(--tile-height);
  flex-grow: 1;
`;

export const NoWrap = styled.span`
  white-space: nowrap;
`;

export const ForYouRoot = styled(Vertical).attrs({ gap: 2 })`
  gap: var(--double-unit);
  margin: 0 calc(-1 * var(--double-unit));
  padding-bottom: var(--double-unit);
`;

export const NegativeMargin = styled.div`
  margin: calc(-1 * var(--double-unit));
`;
